package `fun`.adaptive.resource.document

object Documents